import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const BASE = `${API_URL}/api/admin/external-lessons`;

export const getAllExternalLessonClicks = (token, params = {}) =>
  axios.get(`${BASE}/clicks`, {
    params,
    headers: { 'Authorization': `token ${token}` }
  }).then(r => r.data);

export const getClicksForLesson = (lessonId, token) =>
  axios.get(`${BASE}/${lessonId}/clicks`, { headers: { 'Authorization': `token ${token}` }}).then(r => r.data);
